<template>
  <Layout :containers="containers">
    <template v-slot:header>
      <DefaultHeroBar
        :hasQuickStartCallout="false"
        :section="'adviserFaqsHeader'"
      />
    </template>
    <template v-slot:faqs>
      <section class="adviser-section">
        <h1 class="page-title">Adviser Frequently Asked Questions</h1>
        <AdviserFaqCategories :categories="categories" />
      </section>
    </template>
    <template v-slot:channelCta>
      <AdviserChannelSelector
        :heading="channelCta.heading"
        :subtitle="channelCta.subtitle"
        showAllChannels
      />
    </template>
    <template v-slot:linkCards>
      <section class="adviser-link-cards">
        <AdviserBenefitCardGrid :cards="linkCards" />
      </section>
    </template>
  </Layout>
</template>

<script>
  import {
    ADVISER_CHANNEL_CTA,
    FAQS_PAGE_LINK_CARDS,
  } from '@/constants/adviser-enrolment/adviser-content';
  import Layout from '../../common/layouts/Layout.vue';
  import DefaultHeroBar from '../../common/DefaultHeroBar.vue';
  import AdviserFaqCategories from './AdviserFaqCategories.vue';
  import AdviserChannelSelector from './AdviserChannelSelector.vue';
  import AdviserBenefitCardGrid from './AdviserBenefitCardGrid.vue';

  export default {
    name: 'AdviserFaqs',
    components: {
      Layout,
      DefaultHeroBar,
      AdviserFaqCategories,
      AdviserChannelSelector,
      AdviserBenefitCardGrid,
    },
    data() {
      return {
        channelCta: ADVISER_CHANNEL_CTA,
        linkCards: FAQS_PAGE_LINK_CARDS,
      };
    },
    metaInfo: {
      meta: [
        {
          name: 'robots',
          content: 'nofollow',
        },
        {
          name: 'robots',
          content: 'noindex',
        },
      ],
    },
    computed: {
      categories() {
        return this.whitelabel.adviserFAQs;
      },
      containers() {
        return [
          {
            name: 'header',
            background: 'countryPattern',
            class: 'hero-banner',
          },
          {
            name: 'faqs',
            background: 'countryPattern',
            fadedRow: true,
          },
          { name: 'channelCta' },
          { name: 'linkCards' },
        ];
      },
    },
  };
</script>

<style scoped lang="scss">
  @import '../../../constants/styles/adviser-pages.scss';

  .adviser-section {
    @include adviser-content-column;
    padding-top: 80px;
  }

  ::v-deep .channel-selector-wrapper {
    margin-top: $adviser-section-gap;
  }

  .adviser-link-cards {
    @include adviser-content-column;
    margin-top: $adviser-section-gap;
    padding-bottom: $adviser-footer-gap;
  }

  .page-title {
    @include adviser-heading-a;
    color: $adviser-text-black;
    margin-bottom: 60px;
  }
</style>
